module.exports = __webpack_public_path__ + "media/images/homes/CashDiscount-869e6ae0bc97f8d90a63ff229a768dc2.png";